export const BREAKPOINTS = {
  MOBILE: {
    MIN: 320,
    MAX: 669
  },
  TABLET: {
    MIN: 670,
    MAX: 999
  },
  DESKTOP: {
    MIN: 1000,
    MAX: 1439
  },
  LARGE: {
    MIN: 1440,
    MAX: 1920
  }
};
